<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <pillar-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></pillar-add-form>
                <pillar-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></pillar-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import PillarAddForm from './forms/add/representations/WizardForm'
    import PillarUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../pillarStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            PillarAddForm,
            PillarUpdateForm
        },

    }
</script>
